import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoVinculacionMinimoReferencia } from '../_models/producto-vinculacion-minimo-referencia';

@Injectable({
  providedIn: 'root'
})
export class ProductoVinculacionMinimoReferenciaService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosVinculacionesMinimoReferencias/';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoVinculacionMinimoReferencia[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + 'enabled' ).pipe( map( res => res as ProductoVinculacionMinimoReferencia[] ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + 'producto/' + idProducto ).pipe( map( res => res as ProductoVinculacionMinimoReferencia[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + id ).pipe( map( res => res as ProductoVinculacionMinimoReferencia ) );
  }

  crear( regCrear: ProductoVinculacionMinimoReferencia ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoVinculacionMinimoReferencia ) );
  }

  actualizar( regActualizar: ProductoVinculacionMinimoReferencia ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regCrear: ProductoVinculacionMinimoReferencia[] ) {
    regCrear.map( ( s: ProductoVinculacionMinimoReferencia ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + 'bulk', regCrear ).pipe( map( res => res as ProductoVinculacionMinimoReferencia[] ) );
  }

  listadoPorProductoAnalizamos( idProducto: string ) {
    return this.httClient.get( this.rutServicio + 'producto/' + idProducto + '/analizamos'  ).pipe( map( res => res as ProductoVinculacionMinimoReferencia[] ) );
  }

  listadoPorProductoConTipoPersonaAnalizamos( idProducto: string, idTipoPersona: string ) {
    return this.httClient.get( this.rutServicio + 'producto/' + idProducto + '/tipoPersona/'+ idTipoPersona + '/analizamos'  ).pipe( map( res => res as ProductoVinculacionMinimoReferencia[] ) );
  }

  listadoPorProductoDigital( idProducto: string ) {
    return this.httClient.get( this.rutServicio + 'producto/' + idProducto + '/digital' ).pipe( map( res => res as ProductoVinculacionMinimoReferencia[] ) );
  }

}
